import { useTranslation } from "react-i18next";
import { NavigationListLink } from "@caspeco/casper-ui-library.components.navigation-list";
import { Text } from "@caspeco/casper-ui-library.components.text";
import { getLocalStorage } from "helpers/local-storage-helper/local-storage-helper";
import { IAppLinks } from "types/app";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import {
	ThemeColorVariable,
	ThemeIconSizeVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Icon, Icons } from "@caspeco/casper-ui-library.components.icon";

export function ListItemPrivacyPolicy() {
	const links = getLocalStorage<IAppLinks>("links");
	const privacyPolicyURL = links?.privacyPolicyURL;
	const { t } = useTranslation();
	return (
		<NavigationListLink href={privacyPolicyURL} target="_blank">
			<Flex align="center" justifyContent="space-between">
				<Flex gap={ThemeSpaceVariable.Small} align="center">
					<Icon
						icon={Icons.File}
						size={ThemeIconSizeVariable.Small}
						color={ThemeColorVariable.OnBackground}
					/>
					<Text color={ThemeColorVariable.OnBackground}>{t("app_privacy_policy")}</Text>
				</Flex>
				<Icon
					icon={Icons.LinkExternal}
					size={ThemeIconSizeVariable.Small}
					color={ThemeColorVariable.OnBackground}
				/>
			</Flex>
		</NavigationListLink>
	);
}
